// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2":"supplierOutbound","372":"adminB2cToolbox","487":"supplierSku","627":"adminSku","665":"adminSupportCaseManagement"}[chunkId] + "." + {"2":"f4aadd38","372":"f4aadd38","487":"f4aadd38","627":"f4aadd38","665":"f4aadd38"}[chunkId] + ".chunk.css";
};